module.exports = __webpack_public_path__ + "img/50h100_povorotnoe.89651d81.svg";